import { render, staticRenderFns } from "./research-papers.html?vue&type=template&id=100d2fd0&scoped=true&"
import script from "./research-papers.js?vue&type=script&lang=js&"
export * from "./research-papers.js?vue&type=script&lang=js&"
import style0 from "./research-papers.scss?vue&type=style&index=0&id=100d2fd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100d2fd0",
  null
  
)

export default component.exports